export enum EmbedType {
  Youtube = 'YOUTUBE',
  Loom = 'LOOM',
  Unsupported = 'UNSUPPORTED',
}

export interface YoutubeUrl {
  type: EmbedType.Youtube;
  url: string;
  videoId: string;
}

export interface LoomUrl {
  type: EmbedType.Loom;
  url: string;
  videoId: string;
}

export interface UnsupportedUrl {
  type: EmbedType.Unsupported;
  url: string;
}

export type ParsedUrl = YoutubeUrl | LoomUrl | UnsupportedUrl;
